<template>
  <div>
    <div class="row align-center">
      <span class="flex">{{ stats.displayName }}</span>
      <v-chip
        class="body-2 tenda-grey--text"
        color="tenda-grey-outline"
        small
        outline
      >
        {{ stats.total }}
      </v-chip>
    </div>

    <div class="row align-center flex">
      <el-tooltip
        v-for="status in possibleStatuses"
        :key="status.status"
        :content="status.status"
      >
        <div
          :class="status.color"
          class="mx-1 box-stats body-2 flex text-center"
        >
          {{ stats[status.status] }}
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "JobCard",

  props: {
    stats: {
      type: Object,
      required: true,
    },
  },

  computed: {
    possibleStatuses() {
      return [
        {
          status: "completed",
          color: "tenda-green--text tenda-green-outline",
        },
        {
          status: "failed",
          color: "tenda-red--text tenda-red-outline",
        },
        {
          status: "running",
          color: "tenda-orange--text tenda-orange-outline",
        },
        {
          status: "scheduled",
          color: "tenda-purple--text tenda-purple-outline",
        },
        {
          status: "queued",
          color: "tenda-blue--text tenda-blue-outline",
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/admin/Scheduler/JobCard.vue